import React, {Component} from 'react'
import styles from './NotFound.css'
import Button from '../Button'
import SlideShow from '../SlideShow'
import Link from '../Link'

const images = [
  require('./MCA - Pipilotti Rist - Gnade Donau Gnade2.jpg'),
  require('./onepage_slide_pipilotti_2.jpg'),
  require('./carousel_4th-FLOOR_VIEW-6_SCALE-A.jpg'),
]

export default class NotFound extends Component {
  render () {
    return (
      <div className={styles.cont} style={{
        backgroundImage: this.props.image ? 'url('+this.props.image+')' : '',
      }}>

        <div className={styles.slideShow}>
          <SlideShow slideShow={images}/>
        </div>


        <div className={styles.innerCont} style={{
          height: (window.innerHeight - 81) + 'px',
        }}>
          <div className={styles.primaryTitle +' '+ styles.title}>
            ERROR 404
          </div>
          <div className={styles.secondaryTitle +' '+ styles.title}>
            Page Not Found
          </div>
          <div className={styles.right}>
            <div className={styles.title}>
              <div>
                Error
              </div>
              <div className={styles.clearfix}>
                <div className={styles.sep}/>
              </div>
              <div>
                404
              </div>
            </div>
          </div>
        </div>

        <div className={styles.left}>
          <div className={styles.featureDetail}>
            <div className={styles.description}>
              The page could not be found.
            </div>
            <div className={styles.buttons}>
              <Link to='/'>
                <Button theme='white'>Back to home</Button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/Rist/modules/NotFound/index.js